var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-space-between mb-4" },
    [
      _c("v-autocomplete", {
        staticClass: "mr-4 mb-0",
        attrs: {
          outlined: "",
          dense: "",
          loading: _vm.loading,
          clearable: "",
          label: _vm.$t("common.license"),
          items: _vm.licenses,
          "item-text": "key",
          "return-object": "",
          "hide-details": "auto"
        },
        on: {
          change: function($event) {
            return _vm.$emit("input", _vm.license)
          }
        },
        scopedSlots: _vm._u([
          {
            key: "no-data",
            fn: function() {
              return [
                _c("span", { staticClass: "pa-4" }, [
                  _vm._v(_vm._s(_vm.$t("common.noLicenseAvailable")))
                ])
              ]
            },
            proxy: true
          },
          {
            key: "selection",
            fn: function(ref) {
              var item = ref.item
              return [_c("span", [_vm._v(_vm._s(item.key))])]
            }
          },
          {
            key: "item",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("div", { staticClass: "py-1" }, [
                  _c("strong", { staticClass: "d-block" }, [
                    _vm._v(_vm._s(item.key))
                  ]),
                  _c("span", { staticClass: "d-block text-caption" }, [
                    _vm._v(_vm._s(item.name))
                  ]),
                  _c("span", { staticClass: "d-block text-caption" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.activations.max - item.activations.current
                        ) +
                        " "
                    ),
                    _c("span"),
                    _vm._v(" " + _vm._s(_vm.$t("common.seatsRemaining")))
                  ])
                ])
              ]
            }
          }
        ]),
        model: {
          value: _vm.license,
          callback: function($$v) {
            _vm.license = $$v
          },
          expression: "license"
        }
      }),
      _c("va-button", {
        attrs: {
          disabled: _vm.license == undefined,
          loading: _vm.loading,
          cta: _vm.$t("roomWizard.next")
        },
        on: {
          click: function($event) {
            return _vm.$emit("onFinish", _vm.license)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }